module.exports = __webpack_public_path__ + "static/media/dark-logo-fatoraty.612cc5d8.svg";